import { PublicJobSectionGraph } from "../../../../../../graphql.types";

import { MultiFieldSet } from "@/components/utils/useFieldSet";
import { DisabledFormProvider } from "@/flokit/compound/inputs/contexts/disabled-form-context";
import { JobAppSelfIdQuestionAnswerRequest } from "modules/api-docs";
import { SelfApplySectionContainer } from "../../../../../components/self-apply-section-container";
import { GovtContractorSelfIdFormFragment } from "./components/govt-contractor-self-id-form-fragment";

export const GovtContractorSelfIdSection = (props: {
  section: PublicJobSectionGraph;
  orgFriendlyName: string;
  fieldSet?: MultiFieldSet<JobAppSelfIdQuestionAnswerRequest>;
}) => {
  const { section } = props;

  return (
    <DisabledFormProvider disabled={true}>
      <SelfApplySectionContainer.Container
        key={section.id}
        title={section.name}
        isRequired={section.isRequired}
      >
        <SelfApplySectionContainer.Content>
          <GovtContractorSelfIdFormFragment
            fieldSet={props.fieldSet}
            orgFriendlyName={props.orgFriendlyName}
            isPublic
          />
        </SelfApplySectionContainer.Content>
      </SelfApplySectionContainer.Container>
    </DisabledFormProvider>
  );
};
